module.exports = __webpack_public_path__ + "media/images/writer/user_extension_notification_mailer/commercial_video-46ef56e5ed814047e1f87b09c9eb8877.png";